import React, { ReactElement } from "react";
import { useAppSelector } from "redux/hooks";
import {
  Typography,
  Box,
} from "@mui/material";
import FontAwesomeIcon from "components/shared/FontAwesomeIcon";
import styles from './styles.module.scss'
import { convertBeginToDate, convertOddValue } from "services/utils";

export default function EventsMobile(): ReactElement {
  const playedCoupon = useAppSelector(state => state.coupon.playedCoupon);

  return (
    <Box className={styles.events}>
      {/* Events Table Mobile */}
      <Box>
        {
          playedCoupon &&
          playedCoupon.odds.map(element => {
            const fullTime = convertBeginToDate(element.event.begin)
            const date = fullTime.split(" ")[0]
            const time = fullTime.split(" ")[1]
            return (
              <Box key={element.unique} className={styles.event}>
                <Box className={styles.eventHeader}>
                  <Typography className={styles.eventHeaderText}>{element.category.label} - {element.tournament.label}</Typography>
                  <Typography className={styles.eventHeaderText}>
                    {date} - {time}
                  </Typography>
                </Box>
                <Box className={styles.eventContent}>
                  <Typography className={styles.eventLabel}>{element.event.label}</Typography>
                  <Box className={styles.stateBox}>
                    <Box className={styles.stateFix}>
                      <Typography className={styles.eventLabelFix}>{element.fix ? "F" : null}</Typography>
                      <Typography className={styles.eventLabelFix}>
                        <Box className={
                          element.odd.running
                            ? styles.stateYellow
                            : element.odd.winner
                              ? styles.stateGreen
                              : element.odd.void
                                ? styles.stateWhite
                                : styles.stateRed}>
                          <FontAwesomeIcon type="fas" name="circle" />
                        </Box>
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* add result */}
                <Box className={styles.eventResultRow}>
                  {element.event.result}
                </Box>

                <Box className={styles.eventMarket}>
                  <Typography className={styles.eventMarketText}>{element.market.label} ({element.odd.label}) {element.odd.extra && element.odd.extra.length > 0 ? element.odd.extra : element.odd?.spread}</Typography>
                  <Typography className={styles.eventMarketText}>{convertOddValue(element.value)}</Typography>
                </Box>
              </Box>
            )
          })}
      </Box>
    </Box>
  )
}